import { useCallback, useEffect } from "react";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "utils/api";

export type Company = {
  name: string;
  slug: string;
  logo: string;
  id: string;
  loginpage_logo: string | null;
};

export const useAuthenticationSlug = (): {
  company: Company | undefined;
  isLoading: boolean;
} => {
  const location = useLocation();
  const navigate = useNavigate();

  const [company, setCompany] = useState<Company>();
  const [isLoading, setIsLoading] = useState(false);

  const getCompany = useCallback(
    async (slug: string) => {
      try {
        setIsLoading(true);
        const { company } = await apiRequest("/supabase/public/companyBySlug", {
          slug,
        });
        setCompany(company);
      } catch (err) {
        if (slug !== "set_password" && slug !== "update") {
          navigate("/login");
        }
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  useEffect(() => {
    const slug = location.pathname.split("/").pop();
    if (
      slug === "set_password" ||
      (slug && !["register", "login", "reset", "account", "update"].includes(slug))
    ) {
      getCompany(slug);
    }
  }, [getCompany, location.pathname]);

  return {
    company,
    isLoading,
  };
};
